import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import { setActivePage, setComparedCouncil } from '../../actions/ui';
import styles from './compare-select-page.module.scss';
import Button from '../../components/button';
import Select from 'react-select';
import classNames from 'classnames';
import '../../styles/overrides.css';

class CompareSelectPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCouncil: null,
    };
    this.goToCouncilPage = this.goToCouncilPage.bind(this);
    this.showComparison = this.showComparison.bind(this);
    this.getSelectOptions = this.getSelectOptions.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
  }
  goToCouncilPage() {
    const { setActivePage } = this.props;
    setActivePage('council');
  }

  showComparison() {
    const { setComparedCouncil } = this.props;
    const { selectedCouncil } = this.state;
    if (!selectedCouncil) return;
    setComparedCouncil(selectedCouncil.value);
    this.goToCouncilPage();
  }

  onSelectChange(council) {
    this.setState({ selectedCouncil: council });
  }

  renderCouncils(councils) {
    const { selectedCouncil } = this.state;
    return councils.map((council) => {
      return (
        <div
          key={council.id}
          role="button"
          onClick={(e) => {
            this.setState({
              selectedCouncil: {
                label: council.name,
                value: council.id,
              },
            });
          }}
          className={classNames({
            [styles.listItem]: true,
            [styles.listItemActive]: selectedCouncil
              ? selectedCouncil.value === council.id
              : false,
          })}
        >
          {council.name}
        </div>
      );
    });
  }

  renderOtherCouncils() {
    const { councils, activeCouncil } = this.props;
    const classificationCouncils = councils.filter((council) => {
      return (
        council.id !== activeCouncil.id &&
        council.classification === activeCouncil.classification
      );
    });

    return (
      <div>
        <h4 className={styles.classificationHeadline}>
          {activeCouncil.classification}
        </h4>
        <div className={styles.councilList}>
          {this.renderCouncils(classificationCouncils)}
        </div>
      </div>
    );
  }

  renderCouncilList() {
    return this.renderOtherCouncils();
  }

  getSelectOptions() {
    const { councils, activeCouncil } = this.props;
    return councils
      .filter((council) => council.id !== activeCouncil.id)
      .map((council) => {
        return {
          label: council.name,
          value: council.id,
        };
      });
  }

  renderSelect() {
    const { selectedCouncil } = this.state;
    return (
      <div className={styles.councilSelect}>
        <Select
          className="allOtherCouncilsDropdown red"
          name="allOtherCouncilsDropdown"
          placeholder={'Search for council'}
          value={selectedCouncil}
          onChange={this.onSelectChange}
          options={this.getSelectOptions()}
          clearable={false}
        />
      </div>
    );
  }

  renderButtonRow() {
    const { selectedCouncil } = this.state;
    return (
      <div className={styles.buttonsRow}>
        <button
          type="button"
          className={styles.backLink}
          onClick={this.goToCouncilPage}
        >
          <img
            className={styles.backLinkImage}
            src={`${process.env.PUBLIC_URL}/img/close-icon.svg`}
            alt="chevron icon"
          />
          close
        </button>
        <Button disabled={!selectedCouncil} whenOnClick={this.showComparison}>
          show comparison
        </Button>
      </div>
    );
  }

  render() {
    const { activeCouncil } = this.props;
    return (
      <div className={styles.compareSelectPageWrapper}>
        {this.renderButtonRow()}
        <div className={styles.heading}>{activeCouncil.name}</div>
        <h3 className={styles.chooseHeadline}>Choose a council to compare</h3>
        <div className={styles.formWrapper}>
          <form>
            {this.renderCouncilList()}
            <div className={styles.councilDropdown}>
              <div className={styles.subHeading}>
                All other councils in Queensland
              </div>
              <div />
              {this.renderSelect()}
            </div>
          </form>
        </div>
        {this.renderButtonRow()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActivePage,
  setComparedCouncil,
};

const mapStateToProps = (state) => ({
  activeCouncil: selectors.getActiveCouncil(state),
  councils: selectors.getCouncils(state),
});

CompareSelectPage.propTypes = {
  councils: PropTypes.arrayOf(PropTypes.object),
  activeCouncil: PropTypes.object.isRequired,
  setActivePage: PropTypes.func.isRequired,
  setComparedCouncil: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareSelectPage);



// WEBPACK FOOTER //
// ./src/pages/compare-select-page/compare-select-page.js